
import Vue from 'vue'
import Router from 'vue-router'
import firebase from 'firebase'

import People from '../components/People'
import Login from '../components/Login'
import SignUp from '../components/SignUp'

Vue.use(Router)

let router = new Router({
    routes: [{
            path: '/',
            redirect: '/login'
        },
        {
            path: '/login',
            name: 'Login',
            component: Login
        },
        {
            path: '/signup',
            name: 'SignUp',
            component: SignUp
        },
        {
            path: '/people',
            name: 'People',
            component: People,
            meta: {
                requiresAuth: true
            }
        }
    ]
})

router.beforeEach((to, from, next) => {
    let currentUser = firebase.auth().currentUser
    let requiresAuth = to.matched.some(record => record.meta.requiresAuth)

    if (requiresAuth && !currentUser) next('login')
    else if (!requiresAuth && currentUser) next('people')
    else next()
})

export default router


// WEBPACK FOOTER //
// ./src/router/index.js